import './styles/main.scss';
import { renderMenuPage } from './scripts/controllers/controller';
import { loadQuestions } from './scripts/services/question-service';
import { local } from './scripts/services/localeStorageService';

renderMenuPage();
loadQuestions();
local.generateAllLocalStorage();
console.log(`
Самооценка 195/220
На данный момент реализован весь основной функционал, если вам будет не сложно, пожалуйста, отложите проверку моего проекта хотя бы на день, до утра 25 числа.
Буду очень благодарна(хотелось бы еще успеть реализовать дополнительный функционал на +10баллов минимум). Если есть вопросы по реализации - пишите в Телеграмм или Дискорд, я всегда на связи. 
Спасибо за уделенное время!
НА ДАННЫЙ МОМЕНТ:
Не выполненные пункты:
-Одновременная загрузка и плавная смена изображений --10;
-Дополнительный функционал на выбор --20;
Частично выполненные пункты:
+ 5 баллов за каждую уникальную сложную анимацию, но не больше 20 баллов:
     - анимация звезд в конце раунда в зависмости от количества верных ответов +++5 баллов из 20;
`)
